import { useLayoutEffect } from 'react';
import type { ReactNode } from 'react';

export interface ExternalRedirectProps {
  children?: ReactNode;
  delay?: number;
  to: string;
}
export function ExternalRedirect({ to, delay, children }: ExternalRedirectProps) {
  useLayoutEffect(() => {
    if (typeof delay === 'number') {
      const timeout = setTimeout(() => {
        window.location.href = to;
      }, delay);
      return () => clearTimeout(timeout);
    }

    window.location.href = to;
    return () => {};
  }, [to, delay]);

  return children ? (
    // parent is jsx. this prevents an error. look into fixing this issue lint error later
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  ) : null;
}
